import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ContactForm } from "./ContactForm";
import { useLang } from "../../i18n";

const WA = "https://wa.me/393515865985?text=" + encodeURIComponent("Ciao, vorrei ricevere il listino prezzi e maggiori informazioni sui box di cashmere.");

export const Contact = () => {
  const { t } = useLang();
  const info = [
    { icon: Phone, l: t("ct.l_phone"), v: "351 586 5985", href: "tel:+393515865985" },
    { icon: Mail, l: t("ct.l_email"), v: "kashmiracompany96@gmail.com", href: "mailto:kashmiracompany96@gmail.com" },
    { icon: MapPin, l: t("ct.l_sede"), v: "Prato (Firenze), 50100" },
    { icon: Clock, l: t("ct.l_hours"), v: t("ct.v_hours") },
  ];

  return (
    <section id="contatti" data-testid="contact-section" className="py-24 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-16 lg:gap-20">
        <div className="lg:col-span-5">
          <Reveal><Eyebrow>{t("ct.eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
              {t("ct.h2a")} <em className="text-[#9A4930]">{t("ct.h2em")}</em>{t("ct.h2b")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#57534E] leading-relaxed">{t("ct.p")}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-cta-button"
              className="btn-pill mt-10 w-full sm:w-auto justify-center bg-[#1FA855] text-white hover:!bg-[#178a45] !gap-3"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2Zm0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.23 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28Z" />
              </svg>
              {t("ct.wa")}
            </a>
          </Reveal>
          <dl className="mt-12 grid sm:grid-cols-2 gap-x-8 gap-y-10">
            {info.map(({ icon: Icon, l, v, href }, i) => (
              <Reveal key={l} delay={0.06 * i} y={20}>
                <div data-testid={`contact-info-${i}`}>
                  <dt className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#57534E]">
                    <Icon className="w-4 h-4 text-[#9A4930]" /> {l}
                  </dt>
                  <dd className="mt-2 font-serif text-xl text-[#1C1917]">
                    {href ? <a href={href} data-testid={`contact-link-${i}`} className="break-all hover:text-[#9A4930] transition-colors">{v}</a> : v}
                  </dd>
                </div>
              </Reveal>
            ))}
          </dl>
        </div>
        <Reveal delay={0.15} className="lg:col-span-7">
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
};
